import { useCallback } from 'react';
import axiosInstance from '../../../axiosInstance';

/**
 * useSubformApprovalsApi Hook
 *
 * Pure API hook for subform approval operations.
 * Handles creating and removing section approvals, and fetching approval status.
 *
 * @returns {Object} - { approveSubform, unapproveSubform, getApprovalsByRequestProgress }
 */
const useSubformApprovalsApi = () => {
  const approveSubform = useCallback(
    async ({ subformId, formId, requestId, requestProgressId }) => {
      const response = await axiosInstance.post(
        '/api/subform-approvals/approve',
        {
          subformId,
          formId,
          requestId,
          requestProgressId,
        }
      );
      return response.data;
    },
    []
  );

  const unapproveSubform = useCallback(
    async ({ subformId, formId, requestProgressId, requestId }) => {
      const response = await axiosInstance.delete(
        '/api/subform-approvals/approve',
        {
          data: {
            subformId,
            formId,
            requestProgressId,
            ...(requestId != null && { requestId }),
          },
        }
      );
      return response.data;
    },
    []
  );

  const getApprovalsByRequestProgress = useCallback(
    async (requestProgressId) => {
      const response = await axiosInstance.get(
        `/api/subform-approvals/by-request-progress/${requestProgressId}`
      );
      return response.data;
    },
    []
  );

  const getApprovalsByRequest = useCallback(async (requestId) => {
    const response = await axiosInstance.get(
      `/api/subform-approvals/by-request/${requestId}`
    );
    return response.data;
  }, []);

  return {
    approveSubform,
    unapproveSubform,
    getApprovalsByRequestProgress,
    getApprovalsByRequest,
  };
};

export default useSubformApprovalsApi;
